module.exports = __webpack_public_path__ + "static/logo.b372e1bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/assets/logo.svg
// module id = 621
// module chunks = 114276838955818